import PairReceipts from "../../../../components/Finance/ProvidersExpenses/Receipts/PairReceipts/PairReceipts";

const FinanceReceiptsScreen = () => {
  return (
    <>
      <PairReceipts />
    </>
  );
};

export default FinanceReceiptsScreen;
